// Typelizer digest 130b2aa497db3c2da6fbe308a57f916b
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** POST /c/:company_id/sales_documents/:sales_document_id/advance_invoices */
  create: (
    params: { salesDocumentId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/c/:company_id/sales_documents/:sales_document_id/advance_invoices', params, options),
    method: 'post',
  }),
}
